export default __webpack_public_path__ + "static/media/LeftChevron.37a65414.svg";